import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import whiteLogo from '../../assets/images/logo/Haylo-logo-white.png';
import goldLogo from '../../assets/images/logo/Haylo-for-white-background.png';
import referenceLogo from '../../assets/images/social-gallery/haylo-gold.png';
import actionImage from '../../assets/images/social-gallery/NVO-FE-MR.jpg';
import './experience.css';

export const SG_DEFAULT_BACKGROUND = '#001622';
export const SG_DEFAULT_ACCENT = '#FFCE32';
export function foregroundFor(background) {
  const hex = /^#[0-9a-f]{6}$/i.test(background || '') ? background : '#FFFFFF';
  const rgb = [1, 3, 5].map(offset => parseInt(hex.slice(offset, offset + 2), 16) / 255)
    .map(value => value <= .04045 ? value / 12.92 : Math.pow((value + .055) / 1.055, 2.4));
  const luminance = rgb[0] * .2126 + rgb[1] * .7152 + rgb[2] * .0722;
  return (luminance + .05) / .05 >= 1.05 / (luminance + .05) ? '#000000' : '#FFFFFF';
}
export function experienceTheme(data = {}) {
  const gradient = data.background_type === 'gradient';
  const valid = /^#[0-9a-f]{6}$/i.test(data.background_color || '');
  const custom = gradient || data.background_custom || data.gallery_background_custom
    || (valid && !['#FFFFFF', SG_DEFAULT_BACKGROUND].includes(data.background_color.toUpperCase()));
  const background = custom && valid ? data.background_color : SG_DEFAULT_BACKGROUND;
  const end = /^#[0-9a-f]{6}$/i.test(data.background_gradient_color || '') ? data.background_gradient_color : SG_DEFAULT_ACCENT;
  const rawAngle = Number(data.background_gradient_angle);
  const angle = Number.isInteger(rawAngle) && rawAngle >= 0 && rawAngle <= 360 ? rawAngle : 135;
  return { background, foreground: foregroundFor(background), gradient, end, angle, custom: !!custom };
}
export function HayloLogo({ footer = false, light = false, brand = false }) {
  return <span className={`sgx-haylo-logo ${footer ? 'sgx-footer-logo' : ''}`}><img src={brand && !light ? referenceLogo : light ? goldLogo : whiteLogo} alt={footer ? 'Haylo' : 'The Haylo'} />{!light && !brand && <span className="sgx-logo-disc" aria-hidden="true" />}</span>;
}
export function VenueBrand({ data }) {
  return data.logo_url ? <img className="sgx-venue-logo" src={data.logo_url} alt={data.venue_name || 'Venue logo'} /> : <HayloLogo brand light={experienceTheme(data).foreground === '#000000'} />;
}
export function ExperienceFooter({ data }) {
  return <footer className="sgx-powered"><span className="sgx-powered-label">Powered by</span><HayloLogo footer light={experienceTheme(data).foreground === '#000000'} /></footer>;
}
export default function ExperienceShell({ data = {}, children, view = 'media', preview = false, onClose }) {
  const theme = experienceTheme(data);
  return <div className={`sg-experience ${preview ? 'sg-patron-preview' : ''} ${theme.custom ? 'sgx-custom' : ''} ${theme.gradient ? 'sg-patron-gradient' : ''}`} style={{ backgroundColor: theme.background, color: theme.foreground,
    backgroundImage: theme.gradient ? `linear-gradient(${theme.angle}deg, ${theme.background}, ${theme.end})` : 'none', '--sg-background': theme.background, '--sg-foreground': theme.foreground, '--sg-action-image': `url("${actionImage}")` }}>
    <div className={`sgx-screen sgx-${view}-screen`}>{view !== 'media' && <header className="sgx-topbar"><button type="button" className="sgx-back" onClick={onClose}><FiChevronLeft aria-hidden="true" />Back to photo</button><VenueBrand data={data} /></header>}{children}</div>
  </div>;
}
